import { render } from "./NotFound.vue?vue&type=template&id=d34633ac&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=d34633ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d34633ac"

export default script